<p>applicant-details works!</p>
